<template>
  <v-app id="inspire">
    <v-app-bar 
      app 
      color="white" 
      flat 
      v-if="$store.state.userLogIn == true"
      elevation="1"
      class="modern-app-bar"
    >
      <v-container class="py-2 fill-height" fluid>
        <div class="d-flex align-center">
          <v-btn 
            rounded 
            text 
            :class="['modern-nav-btn', { 'active': styleButton != '' }]"
            @click="clickMenu({ name: 'center' })" 
            v-if="$store.state.userData.roleId == 1 || $store.state.userData.roleId == 5"
            class="mx-1"
          >
            <v-icon left class="modern-icon"> mdi-home-circle-outline </v-icon>
            <span class="nav-text">مركز التراث</span>
          </v-btn>
          
          <v-btn 
            rounded 
            text 
            :class="['modern-nav-btn', { 'active': styleButtonTwo != '' }]"
            @click="clickMenu({ name: 'centerTraining' })" 
            v-if="$store.state.userData.roleId == 1"
            class="mx-1"
          >
            <v-icon left class="modern-icon"> mdi-atom-variant </v-icon>
            <span class="nav-text">مركز التراث للتدريب والتطوير</span>
          </v-btn>
          
          <v-btn
            rounded
            text
            :class="['modern-nav-btn', { 'active': styleButtonThree != '' }]"
            @click="clickMenu({ name: 'edo' })"
            v-if="$store.state.userData.roleId == 1 || $store.state.userData.roleId == 5 || $store.state.userData.roleId == 7"
            class="mx-1"
          >
            <v-icon left class="modern-icon"> mdi-atom </v-icon>
            <span class="nav-text">ايدو بايونير</span>
          </v-btn>
          
          <v-btn 
            rounded 
            text 
            :class="['modern-nav-btn', { 'active': styleButtonFour != '' }]"
            @click="clickMenu({ name: 'pharmacy' })" 
            v-if="$store.state.userData.roleId == 1"
            class="mx-1"
          >
            <v-icon left class="modern-icon"> mdi-pill </v-icon>
            <span class="nav-text">الصيدلية</span>
          </v-btn>
          
          <v-btn
            rounded
            text
            :class="['modern-nav-btn', { 'active': styleButtonFive != '' }]"
            @click="clickMenu({ name: 'company' })"
            v-if="$store.state.userData.roleId == 1 || $store.state.userData.roleId == 6 || $store.state.userData.roleId == 8"
            class="mx-1"
          >
            <v-icon left class="modern-icon"> mdi-domain </v-icon>
            <span class="nav-text">شركة اجيال الوطن</span>
          </v-btn>
        </div>

        <v-spacer></v-spacer>

        <div class="user-profile-section">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-avatar size="40" class="user-avatar" v-bind="attrs" v-on="on">
                <img :src="imageSrc" alt="Avatar" />
              </v-avatar>
            </template>
            <v-list>
              <v-list-item @click="goProfile">
                <v-list-item-icon>
                  <v-icon>mdi-account-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-title>الملف الشخصي</v-list-item-title>
              </v-list-item>
              <v-list-item @click="logOut">
                <v-list-item-icon>
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-title>تسجيل الخروج</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-container>
    </v-app-bar>

    <v-main class="modern-main">
      <div v-if="$store.state.userLogIn == false" class="login-container">
        <router-view />
      </div>
      <v-container v-if="$store.state.userLogIn == true" fluid class="modern-container">
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    styleButton: "border-bottom: 1px solid #0096Ab",
    styleButtonTwo: "",
    styleButtonThree: "",
    styleButtonFour: "",
    styleButtonFive: "",
    imageSrc: "",
  }),
  created() {
    let self = this;
    self.imageSrc = require("./assets/logo.png");
    this.$router.push("/login").catch(() => {});
    // this.$store.dispatch("getUserDate").then(() => {
    //   if (this.$store.state.user) {
    //     self.$store.state.userLogIn = true;
    //     self.$store.state.token = localStorage.getItem("centerLogin");
    //     if (this.$store.state.userData.roleId == 7) {
    //       self.$router.push("/edo").catch(() => {});
    //     } else {
    //       self.$router.push("/").catch(() => {});
    //     }
    //   } else {
    //     self.$router.push("/login").catch(() => {});
    //   }
    // });
  },
  methods: {
    pageLink() {
      return "about";
    },
    logOut() {
      localStorage.removeItem("centerLogin");
      location.reload();
    },
    goProfile() {
      this.$router.push("/profile").catch(() => {});
    },
    clickMenu(link) {
      let self = this;
      switch (link.name) {
        case "center":
          this.styleButton = "border-bottom: 1px solid #0096Ab";
          this.styleButtonTwo = "";
          this.styleButtonThree = "";
          this.styleButtonFour = "";
          this.styleButtonFive = "";
          this.$router.push("/").catch(() => {});
          self.imageSrc = require("./assets/logo.png");
          break;
        case "centerTraining":
          this.styleButton = "";
          this.styleButtonTwo = "border-bottom: 1px solid #0096Ab";
          this.styleButtonThree = "";
          this.styleButtonFour = "";
          this.styleButtonFive = "";
          this.$router.push("/training").catch(() => {});
          self.imageSrc = require("./assets/logo.png");
          break;
        case "edo":
          this.styleButton = "";
          this.styleButtonTwo = "";
          this.styleButtonThree = "border-bottom: 1px solid #0096Ab";
          this.styleButtonFour = "";
          this.styleButtonFive = "";
          this.$router.push("/edo").catch(() => {});
          self.imageSrc = require("./assets/logo.png");
          break;
        case "pharmacy":
          this.styleButton = "";
          this.styleButtonTwo = "";
          this.styleButtonThree = "";
          this.styleButtonFour = "border-bottom: 1px solid #0096Ab";
          this.styleButtonFive = "";
          this.$router.push("/pharmacy").catch(() => {});
          self.imageSrc = require("./assets/logo.png");
          break;
        case "company":
          this.styleButton = "";
          this.styleButtonTwo = "";
          this.styleButtonThree = "";
          this.styleButtonFour = "";
          this.styleButtonFive = "border-bottom: 1px solid #0096Ab";
          this.$router.push("/company").catch(() => {});
          self.imageSrc = require("./assets/company.png");
          break;
      }
    },
  },
};
</script>

<style>
@import url("./font.css");

/* Modern App Bar Styles */
.modern-app-bar {
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.modern-nav-btn {
  height: 48px !important;
  padding: 0 20px !important;
  margin: 0 4px !important;
  border-radius: 24px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative;
  overflow: hidden;
  font-weight: 500 !important;
  text-transform: none !important;
}

.modern-nav-btn:not(.active) {
  color: #6B7280 !important;
}

.modern-nav-btn:not(.active):hover {
  background: rgba(0, 150, 171, 0.08) !important;
  color: #0096Ab !important;
  transform: translateY(-1px);
}

.modern-nav-btn.active {
  background: linear-gradient(135deg, #0096Ab 0%, #00BCD4 100%) !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(0, 150, 171, 0.3) !important;
}

.modern-nav-btn.active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 100%);
  pointer-events: none;
}

.modern-icon {
  font-size: 20px !important;
  margin-right: 8px !important;
}

.nav-text {
  font-size: 14px !important;
  font-weight: 500 !important;
  letter-spacing: 0.5px;
}

/* User Profile Section */
.user-profile-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar {
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid rgba(0, 150, 171, 0.1);
}

.user-avatar:hover {
  transform: scale(1.05);
  border-color: #0096Ab;
  box-shadow: 0 4px 12px rgba(0, 150, 171, 0.2);
}

/* Modern Main Content */
.modern-main {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  min-height: 100vh;
}

.modern-container {
  padding: 24px !important;
}

.login-container {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Enhanced List Styles */
.v-list--rounded {
  padding: 8px !important;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(10px);
}

.v-list--rounded .v-list-item {
  border-radius: 16px !important;
  margin: 4px 8px !important;
  transition: all 0.3s ease !important;
}

.v-list--rounded .v-list-item:hover {
  transform: translateX(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.v-list--rounded .v-list-item--active {
  background: linear-gradient(135deg, #0096Ab 0%, #00BCD4 100%) !important;
  color: white !important;
  box-shadow: 0 4px 16px rgba(0, 150, 171, 0.3) !important;
}

/* Modern Card Styles */
.v-sheet:not(.v-sheet--outlined) {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(20px) !important;
  background: rgba(255, 255, 255, 0.95) !important;
}

/* Primary Color Updates */
.v-application .primary {
  background: linear-gradient(135deg, #0096Ab 0%, #00BCD4 100%) !important;
}

/* Modern Subheader */
.v-subheader {
  font-weight: 600 !important;
  color: #374151 !important;
  text-transform: uppercase !important;
  letter-spacing: 1px !important;
  font-size: 12px !important;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .nav-text {
    display: none;
  }
  
  .modern-nav-btn {
    min-width: 48px !important;
    padding: 0 12px !important;
  }
}

@media (max-width: 768px) {
  .modern-container {
    padding: 16px !important;
  }
  
  .modern-nav-btn {
    margin: 0 2px !important;
  }
}
</style>
